import { apiInstance } from './api';
import { ApiRoutes } from './consts';
import { OrderDirType } from '@app/constants/core.ts';
import {ListResponse} from "@app/models";
import {ReviewsSyncInterface} from "@app/models/reviews-sync.ts";

export type GetPaginatedReviewSyncsParams = {
  page: number;
  perPage?: number;

  businessId?: string;
  startDate?: string;
  endDate?: string;
  status?: string;
  sourceType?: string;
  type?: string;

  sortBy?: 'udpatedAt' | 'createdAt';
  orderDir: OrderDirType;
};

export const getPaginatedReviewSyncs = async (params: GetPaginatedReviewSyncsParams): Promise<ListResponse<ReviewsSyncInterface>> => {
  const response = await apiInstance.get(`${ApiRoutes.ReviewsSync}/`, { params });

  return response.data;

};

